import * as S from './styles'

interface DecorativeCircleProps {
  top: string
  left: string
  radius: number
  thickness: number
}

const DecorativeCircle = ({
  top,
  left,
  radius,
  thickness
}: DecorativeCircleProps) => {
  return (
    <S.DecorativeCircleContainer
      top={top}
      left={left}
      radius={radius}
      thickness={thickness}
    >
      <div></div>
    </S.DecorativeCircleContainer>
  )
}

export default DecorativeCircle
